module.exports = __webpack_public_path__ + "static/media/parallax-bg-6.fe77ad16.jpg";